var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container container-small"},[_c('div',{staticClass:"card card-page"},[_c('div',{staticClass:"card-header border-bottom"},[_c('h2',{staticClass:"text-center"},[_vm._v("Confirmaçao de e-mail")])]),_c('div',{staticClass:"card-body shadow"})])])
}]

export { render, staticRenderFns }